import { gql } from 'graphql-tag';
import { COLLECTION_SHALLOW_FRAGMENT, } from '@annunciate/query/dist/queries/collection';
export const NAV_NODE_FRAGMENT = `
  fragment NavNodeFragment on NavNode {
    name
    link
    openInNewTab
    authenticationStates {
      authenticated
      unauthenticated
    }
  }
`;
export const SETTINGS_FRAGMENT = `
  fragment ChannelSettingsFragment on ChannelSettings {
    comments {
      isEnabled
    }
    isQuickPlayEnabled
    meta {
      title
      description
    }
    nav {
      primary {
        ...NavNodeFragment
        children {
          ...NavNodeFragment
        }
      }
      secondary {
        ...NavNodeFragment
        children {
          ...NavNodeFragment
        }
      }
    }
    search {
      recommendations
    }
    tag {
      recommendations
    }
    account {
      managePurchases {
        name
        link
        isAuthRequired
      }
      links {
        name
        link
        isAuthRequired
      }
    }
  }
`;
export const CHANNEL_GET = gql `
  ${COLLECTION_SHALLOW_FRAGMENT}
  ${NAV_NODE_FRAGMENT}
  ${SETTINGS_FRAGMENT}
  query Channel (
    $id: ID!
  ) {
    channel: Channel(id: $id) {
      collection {
        ...CollectionShallowFragment
      }
      settings {
        ...ChannelSettingsFragment
      }
    }
  }
`;
export const CHANNEL_SETTINGS_GET = gql `
  ${NAV_NODE_FRAGMENT}
  ${SETTINGS_FRAGMENT}

  query ChannelSettings ($id: ID!) {
    channel: Channel(id: $id) {
      settings {
        ...ChannelSettingsFragment
      }
    }
  }
`;
export const CHANNEL_SITEMAP_GET = gql `
  query SiteMap($id: ID!) {
    channel: Channel(id: $id) {
      settings {
        ...ChannelSettingsFragment
      }
    }

    siteMap: SiteMap(id: $id) {
      urls {
        loc
      }
    }
  }
  ${SETTINGS_FRAGMENT}
  ${NAV_NODE_FRAGMENT}
`;
//# sourceMappingURL=channel.js.map